import { useQuery } from 'react-query';
import { CategoriesTopicsTableAPI } from '../../../constants/API';
import axios from 'axios';
import { CategoriesServicesObjectData } from '../../../types/Admin/CategoriesTopicsTypes';
import { getCategoriesOrTopicsData } from '../../../utils/Admin/CategoriesAndServicesTable/getCategoriesOrTopicsData';
import { modifyAllCategoriesTopicsData } from '../../../utils/Admin/CategoriesAndServicesTable/modifyAllCategoriesTopicsData';
import { commonHeaders } from '../../../constants/HeadersAPI';

const transformData = ({ data }): CategoriesServicesObjectData => {
  if (data) {
    const all = modifyAllCategoriesTopicsData(data.categories);
    const parsed = getCategoriesOrTopicsData(data);
    return {
      all,
      sections: parsed.categoriesArr,
      services: parsed.topicsArr
    };
  }
};

export const useGetAllCategoriesTopics = (branchId?: number) => {
  const {
    data: allCategoriesTopicsResp,
    isLoading: isLoadingAllCategoriesTopics,
    isSuccess: isAllCategoriesTopicsReceived
  } = useQuery(
    ['allCategoriesTopics', branchId ?? null],
    async () => {
      const url =
        typeof branchId === 'number'
          ? `${CategoriesTopicsTableAPI.getAllCategoriesTopics}?branchId=${branchId}`
          : CategoriesTopicsTableAPI.getAllCategoriesTopics;
      const resp = await axios.get(url, commonHeaders());
      return resp;
    },
    { select: transformData }
  );
  return {
    allCategoriesTopicsResp,
    isLoadingAllCategoriesTopics,
    isAllCategoriesTopicsReceived
  };
};

